module.exports = __webpack_public_path__ + "img/19267347000123.0f3e5704.png";